import styled from 'styled-components';

export const CardButton = styled.button<{ $selected?: boolean }>`
  width: 100%;
  padding: 16px 24px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.lavenderLight};
  cursor: pointer;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease;
  background-color: ${({ theme, $selected }) =>
    $selected ? theme.colors.yellow.lightestYellow : theme.colors.white};
  background-clip: padding-box;
  box-shadow: ${({ theme, $selected }) =>
    $selected
      ? `0px 0px 0px 1px ${theme.colors.yellow.primary}, 0px 2px 4px 0px rgba(241, 203, 10, 0.2)`
      : `0px 0px 2px 0px rgba(67, 71, 146, 0.1), 0px 0px 1px 0px rgba(67, 71, 146, 0.08)`};
  box-sizing: border-box;

  h3 {
    text-align: center;
  }

  ${({ theme, $selected }) =>
    $selected &&
    `
    border: 1px solid ${theme.colors.yellow.primary};
  `}

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    width: 800px;
    max-width: 100%;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.yellow.lighterYellow};
    border: 1px solid ${({ theme }) => theme.colors.white};
    box-shadow: ${({ theme }) => theme.shadows.container.glowYellow};
  }

  &:active {
    transform: translateY(1px);
  }
`;
